<ng-container *ngIf="values && values.length > 0">
  <mat-list class="checkbox-group">
    <mat-list-item *ngFor="let value of values">
      <mat-checkbox [checked]="isChecked(value)" (change)="toggleCheck(value)">{{ value }}</mat-checkbox>
    </mat-list-item>
  </mat-list>
</ng-container>
